<template>
    <div
        class="modal fade"
        id="modal-select-prestas"
        tabindex="-1"
        aria-labelledby="modal-select-prestas"
        aria-hidden="true"
        role="dialog"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-24 overflow-hidden">
                <div class="modal-header">
                    <div class="block-header">
                        <h3 class="block-title">{{ $t('checkout.serie_modal.select_activities_title') }}</h3>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="block rounded-24 block-transparent mb-0">
                        <div class="block-content fs-sm">
                            <div class="mt-3 mb-3" v-if="prestations.length > 0">
                                <span class="text-muted"
                                    >{{ $t('checkout.serie_modal.select_activities_label') }} <b>{{ selected?.name }}</b
                                    >.</span
                                >
                                <div v-for="(prestation, index) in prestations" :key="index">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            :id="'prestation_' + index"
                                            :name="'prestation_' + index"
                                            :checked="isPrestationSelected(prestation)"
                                            @change="selectPrestation($event, prestation, index)"
                                        />
                                        <label class="form-check-label" :for="'prestation_' + index">{{ prestation.name }}</label>
                                        <input
                                            class="form-input"
                                            type="number"
                                            :value="prestation.qty"
                                            :id="'prestation_qty_' + index"
                                            :name="'prestation_qty_' + index"
                                            @change="changePrestationQty($event, prestation, index)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 mb-3" v-else>{{ $t('checkout.serie_modal.no_activities') }}</div>
                        </div>
                        <div class="block-content block-content-full text-center">
                            <button
                                type="button"
                                class="btn btn-sm btn-alt-danger text-danger me-1"
                                data-bs-dismiss="modal"
                                @click="() => $emit('remove-selected')"
                            >
                                Fermer
                            </button>
                            <button type="button" class="btn btn-sm btn-primary text-white rounded-pill" data-bs-dismiss="modal">
                                {{ $t('common.validate') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
    props: ['selected'],
    data: () => ({
        prestations: [],
    }),
    computed: {
        ...sync('overlay@data', {
            c_prepaidPrestations: 'prepaidPrestations',
        }),
        ...get('overlay@data', {
            c_cartItems: 'cartItems',
        }),
    },
    watch: {
        selected: {
            handler(newVal) {
                if (newVal) {
                    // reset des prestations à afficher dans la modal
                    this.prestations = []
                    this.checkIfSelectedContainsPresta(newVal)
                }
            },
            immediate: true,
        },
    },
    methods: {
        selectPrestation(event, prestation, index) {
            if (event.target.checked) {
                this.c_prepaidPrestations.push({
                    prestation: prestation,
                    prepaid: this.selected,
                    qty: 1,
                })
            } else {
                const idx = this.c_prepaidPrestations.findIndex(
                    (x) => x.prestation.id === prestation.id && x.prepaid?.id === this.selected?.id
                )
                if (idx !== -1) {
                    this.c_prepaidPrestations.splice(idx, 1)
                }
            }
        },

        changePrestationQty(event, prestation, index) {
            const item = this.c_prepaidPrestations.find(
                (x) => x.prestation.id === prestation.id && x.prepaid?.id === this.selected?.id
            )
            if (item) {
                item.qty = event.target.value
            }
        },

        isPrestationSelected(prestation) {
            return this.c_prepaidPrestations.some((x) => x.prestation.id === prestation.id && x.prepaid?.id === this.selected?.id)
        },

        checkIfSelectedContainsPresta(item) {
            //  console.log(item)
            if (item)
                for (const key in this.c_cartItems) {
                    // console.log(parseInt(this.c_cartItems[key].options.item_id))
                    // S'il y a des prestations qui appartiennent à un abonnement ou une cure
                    if (this.c_cartItems[key].options.type == 'App\\Models\\Prestation\\Prestation')
                        if (
                            item.prestations.filter((prestation) => {
                                return prestation.id == parseInt(this.c_cartItems[key].options.item_id)
                            }).length > 0
                        ) {
                            this.prestations.push(this.c_cartItems[key])
                            this.c_prepaidPrestations.push({
                                prestation: this.c_cartItems[key],
                                prepaid: this.selected,
                                qty: this.c_cartItems[key].qty,
                            })
                        }
                }
        },
    },
}
</script>
